import axios from 'axios';
import { Auth } from 'aws-amplify';

const UNAUTHORIZED = 401;

const client = () => {
  const defaultOptions = {
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };

  // Create instance
  const instance = axios.create(defaultOptions);

  // Set the AUTH token for any request
  instance.interceptors.request.use((config) => {
    return Auth.currentSession()
      .then((userSession) => {
        const idToken = userSession.getIdToken().getJwtToken();
        config.headers.Authorization = `Bearer ${ idToken }`;
        return config;
      })
      .catch((_err) => {
        config.headers.Authorization = 'Bearer ThisIsNotAToken';
        return config;
      });
  });

  // Add a response interceptor
  instance.interceptors.response.use((response) => {
    // Do something with response data
    return response.data;
  }, (err) => {
    // Do something with response error
    if (err.response && err.response.status === UNAUTHORIZED) {
      return Auth.signOut().finally(() => {
        const error = new Error();
        error.name = 'UserDoesNotExist';
        error.message = 'User has been logged out';
        throw error;
      });
    }
    return Promise.reject(err);
  });

  return instance;
};

const c = client();

export const uploadAsset = (dataForm) => {
  return c.post('upload', dataForm);
};

export const uploadTemplate = (dataForm, locale) => {
  const form = dataForm;
  console.log('locale', locale);
  return c.post('uploadFile', form);
};

